import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useRef, useState } from "react";
import { extendBlockerHeroStylesheet, extendCommonButtonsStylesheet } from "@devowl-wp/web-cookie-banner";
import { BlockerHeroAudioWaveFromText } from "./hero/audio/waveFromText.js";
import { BlockerHeroDialog } from "./hero/dialog.js";
import { useBlocker } from "../../contexts/blocker.js";
import { Button } from "../common/button.js";
import { BlockerHeroVideoSvgPlayButton } from "./hero/video/svgPlayButton.js";
import { useBlockerStylesheet } from "../../hooks/blocker/useBlockerStylesheet.js";
const BlockerHeroContainer = ({ blockerClassName, blockerOverlayId, ...rest })=>{
    const stylesheet = useBlockerStylesheet();
    const { HeroWrapper, HeroBackgroundWrapper, HeroBackground, HeroTitle, HeroContainer, heroButton, HeroPlayButton, screenReaderOnlyClass } = stylesheet.extend(...extendBlockerHeroStylesheet).extend(...extendCommonButtonsStylesheet);
    const blocker = useBlocker();
    const { texts: { blockerHeadline }, blocker: { presetId, name, visualHeroButtonText, visualContentType, visualThumbnail } } = blocker;
    const ref = useRef();
    const heroContainerRef = useRef();
    const [isHover, setIsHover] = useState(false);
    const { url } = visualThumbnail;
    const title = visualThumbnail.title || name;
    const blockerHeadlineWithName = blockerHeadline.replace(/{{name}}/gi, name);
    const audioWaveText = `${visualThumbnail.title || blockerHeadlineWithName}ThiS iS jUst ANother TEXT TO reACh minIMum length`;
    const showPlayButton = [
        "video-player",
        "audio-player"
    ].indexOf(visualContentType) > -1;
    return /*#__PURE__*/ _jsxs(Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(HeroWrapper, {
                ref: ref,
                ...rest,
                children: [
                    /*#__PURE__*/ _jsx(HeroBackgroundWrapper, {
                        "aria-hidden": true,
                        children: /*#__PURE__*/ _jsx(HeroBackground, {
                            src: url,
                            alt: title
                        })
                    }),
                    /*#__PURE__*/ _jsxs(HeroContainer, {
                        role: "presentation",
                        onMouseEnter: ()=>setIsHover(true),
                        onMouseLeave: ()=>setIsHover(false),
                        ref: heroContainerRef,
                        children: [
                            /*#__PURE__*/ _jsx(HeroTitle, {
                                "aria-hidden": true,
                                children: title
                            }),
                            /*#__PURE__*/ _jsx("a", {
                                href: "#",
                                className: screenReaderOnlyClass,
                                "aria-label": `${blockerHeadlineWithName}, ${title}`,
                                children: title
                            }),
                            visualContentType === "audio-player" && /*#__PURE__*/ _jsx(BlockerHeroAudioWaveFromText, {
                                text: audioWaveText
                            }),
                            visualHeroButtonText && [
                                "audio-player",
                                "video-player"
                            ].indexOf(visualContentType) === -1 ? /*#__PURE__*/ _jsxs(Button, {
                                type: "acceptAll",
                                forceShow: true,
                                busyOnClick: false,
                                className: heroButton,
                                children: [
                                    "\xa0\xa0",
                                    visualHeroButtonText,
                                    "\xa0\xa0"
                                ]
                            }) : showPlayButton && (presetId === "youtube" && visualContentType === "video-player" ? /*#__PURE__*/ _jsx(BlockerHeroVideoSvgPlayButton, {
                                fill: isHover ? "#ff0808" : `rgb(0 0 0 / 70%)`
                            }) : /*#__PURE__*/ _jsx(HeroPlayButton, {}))
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(BlockerHeroDialog, {
                blockerClassName: blockerClassName,
                blockerOverlayId: blockerOverlayId,
                heroContainerRef: heroContainerRef
            })
        ]
    });
};
export { BlockerHeroContainer };
